import { useFormikContext } from 'formik'
import { useRef } from 'react'

import type { RowClickedEvent } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { IPageContainerFormValues } from '~/types/template'
import type { ITranslationRuleError } from '~/types/translation'

import columns from './columns'

import { ModalBody, ModalHeader } from '~/components/Modal/Layout'
import TableWrapper from '~/components/Tables/TableWrapper'

interface Props {
  errors: ITranslationRuleError[]
  onRowClicked: () => void
}

const TranslationRuleErrors = ({ errors, onRowClicked }: Props): ReactElement => {
  const { setFieldValue } = useFormikContext<IPageContainerFormValues>()
  const tableRef = useRef<HTMLDivElement>(null)

  const handleRowClicked = (evt: RowClickedEvent) => {
    setFieldValue('focus', evt.data.placeholder)
    onRowClicked()
  }

  return (
    <>
      <ModalHeader>Translation rule errors</ModalHeader>
      <ModalBody>
        <TableWrapper
          className="with-min-height"
          columnDefs={columns}
          entriesName="translation-rule-errors"
          onRowClicked={handleRowClicked}
          rowData={errors}
          tableRef={tableRef}
        />
      </ModalBody>
    </>
  )
}

export default TranslationRuleErrors
